import { Box, useTheme, styled } from '@mui/material'

export const StyledSubHeader = styled(Box)(() => {
  return `
    display: flex;
    justify-content: space-between;
    align-items: stretch;
    border-radius: 8px;
  `
})

export const StyledSubSections = styled(Box)(() => {
  return `
    display: flex;
    gap: 16px;
    border: 1px solid #E8E8E8;
    border-radius: 6px;
    margin-right: 16px;
    height: 32px;
    padding: 0 16px;
  `
})

export const StyledSubHeaderChildren = styled(Box)(() => {
  return `
    display: flex;
    justify-content: space-between;
    gap: 8px;
    flex: 1;
  `
})

export const StyledSubSection = styled(Box)(({ ...props }) => {
  return `
    display: flex;
    flex-basis: 1;
    justify-content: center;
    align-items: center;
    font-size: 13px;
    font-weight: 400;
    color: ${props.selected ? '#3B82F6' : '#7A8096'};
    line-height: 32px;
    transition: all 0.2s ease-in;
    
    :hover {
     cursor: ${props.selected ? 'default' : 'pointer'};
    }
`
})

export const SubHeaderInfos = styled(Box)(() => {
  const theme = useTheme()
  return `
    display: flex;
    font-size: 13px;
    font-weight: 400;
    line-height: 32px;
    color: ${theme.palette.grey['800']};
  `
})

export const SubHeaderInfosIcon = styled(Box)(({ iconcolor }) => {
  const theme = useTheme()
  return `
    display: flex;
    justify-content: center;
    align-items: center;
    width: 32px;
    height: 32px;
    font-size: 16px;
    font-weight: 400;
    line-height: 32px;
    border-radius: 4px;
    background-color: white;
    color: ${iconcolor || theme.palette.primary.main}
  `
})
